import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Information persistante en haut d'écran — pas une alerte, pas une erreur. */
export function Bandeau({ titre, texte }) {
    return (_jsxs("div", { className: "bandeau", role: "status", children: [_jsx("p", { className: "bandeau__titre", children: titre }), _jsx("p", { children: texte })] }));
}
//# sourceMappingURL=Bandeau.js.map